import {
  FlatEmailReport,
  FlatReportAddressHistory,
  FlatReportAircraft,
  FlatReportAutomobile,
  FlatReportEmailPhoneOrSocialInfo,
  FlatReportEducation,
  FlatReportEmails,
  FlatReportEmployment,
  FlatReportJob,
  FlatReportOwners,
  FlatReportPhoneNumbers,
  FlatReportRisk,
  FlatReportSocial,
  FlatReportVehicles,
  FlatReportWatercraft,
} from 'components/ChatBV/types';

import { normalizeValue, normalizeArray } from '../generalUtils';

export const mapEmailReportToFlatSections = (
  reportData: any
): FlatEmailReport => {
  const peopleData = reportData?.entities?.people?.[0];
  const supportingData = reportData?.supporting?.emails?.[0];

  const owners = reportData?.entities?.people
    ?.slice(0, 3)
    .map((person: any) => ({
      name: normalizeValue(person?.identity?.names?.[0]?.full),
      age: normalizeValue(person?.identity?.ages?.[0]),
      address: normalizeValue(person?.contact?.addresses?.[0]?.full),
      phone: normalizeValue(person?.contact?.phones?.[0]?.number),
      email: normalizeValue(person?.contact?.emails?.[0]?.address),
      social: normalizeValue(person?.social?.usernames?.[0]?.username),
    }));

  return {
    permalink: normalizeValue(reportData?.meta?.permalink),
    identity_or_owner_identity_info: {
      owners: owners as FlatReportOwners[] | undefined,
    },
    trust_and_safety_status_info: {
      fraud_score: normalizeValue(supportingData?.fraud_score),
      deliverability: normalizeValue(supportingData?.deliverability),
      recent_abuse: normalizeValue(supportingData?.recent_abuse),
      is_leaked: normalizeValue(supportingData?.is_leaked),
    } as FlatReportRisk,
    email_phone_or_social_info: {
      phone_number: normalizeValue(peopleData?.contact?.phones?.[0]?.number),
      primary_address: normalizeValue(
        peopleData?.contact?.addresses?.[0]?.full
      ),
      city: normalizeValue(peopleData?.contact?.addresses?.[0]?.parsed?.city),
      state: normalizeValue(peopleData?.contact?.addresses?.[0]?.parsed?.state),
      zip5: normalizeValue(peopleData?.contact?.addresses?.[0]?.parsed?.zip5),
      zip4: normalizeValue(peopleData?.contact?.addresses?.[0]?.parsed?.zip4),
      county: normalizeValue(peopleData?.contact?.addresses?.[0]?.county?.name),
      county_fips: normalizeValue(
        peopleData?.contact?.addresses?.[0]?.county?.fips
      ),
      congressional_district: normalizeValue(
        peopleData?.contact?.addresses?.[0]?.congressional_district
      ),
      phones: normalizeArray(
        peopleData?.contact?.phones?.slice(0, 3)?.map((phone: any) => ({
          phone: normalizeValue(phone?.number),
          type: normalizeValue(phone?.type),
        })) || []
      ) as FlatReportPhoneNumbers[] | undefined,
      emails: normalizeArray(
        peopleData?.contact?.emails?.slice(0, 3)?.map((email: any) => ({
          address: normalizeValue(email?.address),
          type: normalizeValue(email?.type),
        })) || []
      ) as FlatReportEmails[] | undefined,
      addresses: normalizeArray(
        peopleData?.contact?.addresses?.slice(0, 3)?.map((address: any) => ({
          address: normalizeValue(address?.full),
          type: normalizeValue(address?.type),
        })) || []
      ) as FlatReportAddressHistory[] | undefined,
      social: {
        usernames: normalizeArray(
          peopleData?.social?.usernames?.slice(0, 3)?.map((username: any) => ({
            username: normalizeValue(username?.username),
            first_seen_date: normalizeValue(username?.meta?.first_seen_date),
          })) || []
        ),
      } as FlatReportSocial | undefined,
    } as FlatReportEmailPhoneOrSocialInfo,

    vehicles_info: {
      owned_assets: {
        aircraft: normalizeArray(
          peopleData?.vehicles?.aircraft?.slice(0, 3)?.map((vehicle: any) => ({
            name: normalizeValue(vehicle?.name),
            value: normalizeValue(vehicle?.value),
          })) || []
        ) as FlatReportAircraft[] | undefined,
        automobiles: normalizeArray(
          peopleData?.vehicles?.automobiles
            ?.slice(0, 3)
            ?.map((vehicle: any) => ({
              name: normalizeValue(vehicle?.name),
              value: normalizeValue(vehicle?.value),
            })) || []
        ) as FlatReportAutomobile[] | undefined,
        watercraft: normalizeArray(
          peopleData?.vehicles?.watercraft
            ?.slice(0, 3)
            ?.map((vehicle: any) => ({
              name: normalizeValue(vehicle?.name),
              value: normalizeValue(vehicle?.value),
            })) || []
        ) as FlatReportWatercraft[] | undefined,
      },
    } as FlatReportVehicles | undefined,

    jobs_education_or_skills_info: {
      jobs: normalizeArray(
        peopleData?.jobs?.slice(0, 3)?.map((job: any) => ({
          company: normalizeValue(job?.company),
          title: normalizeValue(job?.title),
        })) || []
      ) as FlatReportJob[] | undefined,
      educations: normalizeArray(
        peopleData?.educations?.slice(0, 3)?.map((education: any) => ({
          degree: normalizeValue(education?.known_degrees?.[0]),
          institution: normalizeValue(education?.school),
          attended_start_date: normalizeValue(
            education?.attended?.start_date?.full
          ),
          attended_end_date: normalizeValue(
            education?.attended?.end_date?.full
          ),
        })) || []
      ) as FlatReportEducation[] | undefined,
    } as FlatReportEmployment | undefined,
  };
};
